import { render, staticRenderFns } from "./UploadMp4Dialog.vue?vue&type=template&id=515096e6&scoped=true"
import script from "./UploadMp4Dialog.vue?vue&type=script&lang=js"
export * from "./UploadMp4Dialog.vue?vue&type=script&lang=js"
import style0 from "./UploadMp4Dialog.vue?vue&type=style&index=0&id=515096e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515096e6",
  null
  
)

export default component.exports